/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Footer_TaglineInputs */

const en_app_footer_tagline = /** @type {(inputs: App_Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen to research papers, anywhere.`)
};

const es_app_footer_tagline = /** @type {(inputs: App_Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escucha artículos de investigación, en cualquier lugar.`)
};

/**
* | output |
* | --- |
* | "Listen to research papers, anywhere." |
*
* @param {App_Footer_TaglineInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const app_footer_tagline = /** @type {((inputs?: App_Footer_TaglineInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Footer_TaglineInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_app_footer_tagline(inputs)
	return en_app_footer_tagline(inputs)
});